<template>
    <b-modal v-model="modalOpen" scrollable title="Send til print" size="lg">
        <b-card-text>
            <div class="row">
                <b-col cols="12" md="6">
                    <FormGroup v-model="print.name" label="Antal" rules="required"></FormGroup>
                    <FormGroup v-model="print.price" label="Pris" rules="required"></FormGroup>
                </b-col>
                <b-col cols="12" md="6">
                    <FormGroup v-model="print.gtin" label="Stregkode" rules="required"></FormGroup>
                    <FormGroup v-model="print.quantity" label="Antal" rules="required"></FormGroup>
                </b-col>
            </div>
        </b-card-text>

        <template #modal-footer="{ ok }">

            <b-button variant="secondary" class="py-7 px-15" @click="ok">
                Luk
            </b-button>

            <b-button variant="success" class="py-7 px-15" @click="create(ok)">
                Opret
            </b-button>
        </template>
    </b-modal>
</template>

<script>
    import Toast from '@/components/_toast.vue'

    export default {
        components: {},
        data: () => ({
            modalOpen: false,
            print: {}
        }),
        computed: {},
        watch: {

        },
        props: [],
        created() { },
        mounted() { },
        methods: {
            create(ok) {
                this.$http.post("/api/labels/enqueue", this.print).then(x => {
                    this.$toast({
                        component: Toast,
                        props: {
                            title: "Etikette sat i kø!",
                            icon: 'CheckCircleIcon',
                            variant: 'success',
                        },
                    })

                    ok()
                })
            },
            show() {
                this.modalOpen = true
            }
        },
    }
</script>